export const splitStringByCharacters = (text: string) => {
  if (text.includes(',' || '.')) {
    const splitTextArr = text.split(/[,.]/);
    splitTextArr.forEach((v, i) => {
      if (v.trim() === '') {
        splitTextArr.splice(i, 1);
      }
    });
    const updatedTextArr = [...splitTextArr];
    return updatedTextArr;
  }

  const updatedTextArr = [text];
  return updatedTextArr;
};
